import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './RoomCarousel.css';

function renderMedia(room, className, objPos) {
  const style = objPos ? { objectPosition: objPos } : undefined;
  return room.type === 'video'
    ? <video className={className} src={room.url} autoPlay muted loop playsInline style={style} />
    : <img className={className} src={room.url} alt={room.name || ''} loading="lazy" style={style} />;
}

export default function RoomCarousel({ rooms = [], initialIndex = 0, title, subtitle, ctaLabel, allRoomsLabel }) {
  const [current, setCurrent] = useState(initialIndex);
  const n = rooms.length;

  useEffect(() => { setCurrent(initialIndex); }, [initialIndex]);

  // navigare doar manuală — fără auto-advance

  if (!n) return null;

  const prevIdx = (current - 1 + n) % n;
  const nextIdx = (current + 1) % n;
  const curr = rooms[current];
  const prev = rooms[prevIdx];
  const next = rooms[nextIdx];

  return (
    <section className="room-carousel">
      {(title || subtitle) && (
        <div className="room-carousel__header container">
          {title && <h2 className="room-carousel__title">{title}</h2>}
          {subtitle && <p className="room-carousel__subtitle">{subtitle}</p>}
        </div>
      )}

      <div className="room-carousel__stage">
        {/* Left peek */}
        {n > 1 && (
          <div
            className="room-carousel__item room-carousel__item--side room-carousel__item--left"
            onClick={() => setCurrent(prevIdx)}
          >
            {renderMedia(prev, 'room-carousel__media', 'right center')}
          </div>
        )}

        {/* Center */}
        <div className="room-carousel__item room-carousel__item--center">
          {renderMedia(curr, 'room-carousel__media', 'center')}
          <div className="room-carousel__card">
            {curr.category_group && (
              <span className="room-carousel__card-eyebrow">{curr.category_group}</span>
            )}
            <h3 className="room-carousel__card-name">{curr.name || curr.slug}</h3>
            <Link to={`/camere/${curr.slug}`} className="room-carousel__card-cta">
              {ctaLabel || 'Explorează camera'}
            </Link>
          </div>
        </div>

        {/* Right peek */}
        {n > 1 && (
          <div
            className="room-carousel__item room-carousel__item--side room-carousel__item--right"
            onClick={() => setCurrent(nextIdx)}
          >
            {renderMedia(next, 'room-carousel__media', 'left center')}
          </div>
        )}

        {/* Arrows */}
        {n > 1 && (
          <>
            <button
              className="room-carousel__arrow room-carousel__arrow--prev"
              onClick={() => setCurrent(prevIdx)}
              aria-label="Anterior"
            >&#8592;</button>
            <button
              className="room-carousel__arrow room-carousel__arrow--next"
              onClick={() => setCurrent(nextIdx)}
              aria-label="Următor"
            >&#8594;</button>
          </>
        )}
      </div>

      {/* Dots */}
      {n > 1 && (
        <div className="room-carousel__dots">
          {rooms.map((_, i) => (
            <button
              key={i}
              className={`room-carousel__dot${i === current ? ' active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Camera ${i + 1}`}
            />
          ))}
        </div>
      )}

      {allRoomsLabel && (
        <div className="room-carousel__footer">
          <Link to="/camere" className="room-carousel__all-cta">
            {allRoomsLabel}
          </Link>
        </div>
      )}
    </section>
  );
}
